import { IonAlert, IonIcon } from '@ionic/react';
import { cameraOutline } from 'ionicons/icons';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getCameraPermissionState } from '../../services/utils/cameraUtils';
import { QrScannerModal } from './QrScannerModal';

interface Props {
  onScan: (url: string) => void;
}

export const QrScanButton = ({ onScan }: Props) => {
  const { t } = useTranslation();
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [permissionAlert, setPermissionAlert] = useState(false);
  const [invalidUrlAlert, setInvalidUrlAlert] = useState(false);

  const handleOpen = useCallback(async () => {
    const state = await getCameraPermissionState();
    if (state === 'denied') {
      setPermissionAlert(true);
      return;
    }
    setIsScannerOpen(true);
  }, []);

  return (
    <>
      <IonIcon
        icon={cameraOutline}
        onClick={handleOpen}
        style={{ fontSize: 18, verticalAlign: 'middle', cursor: 'pointer' }}
      />

      <QrScannerModal
        isOpen={isScannerOpen}
        onScan={(url) => { setIsScannerOpen(false); onScan(url); }}
        onDismiss={() => setIsScannerOpen(false)}
        onPermissionDenied={() => { setIsScannerOpen(false); setPermissionAlert(true); }}
        onInvalidUrl={() => setInvalidUrlAlert(true)}
      />

      <IonAlert
        isOpen={permissionAlert}
        onDidDismiss={() => setPermissionAlert(false)}
        header={t('CAMERA.PERMISSION_DENIED_TITLE')}
        message={t('CAMERA.PERMISSION_DENIED_MESSAGE')}
        buttons={[{ text: t('CAMERA.OK'), handler: () => setPermissionAlert(false) }]}
      />

      <IonAlert
        isOpen={invalidUrlAlert}
        onDidDismiss={() => setInvalidUrlAlert(false)}
        header={t('CAMERA.INVALID_URL_TITLE')}
        message={t('CAMERA.INVALID_URL_MESSAGE')}
        buttons={[{ text: t('CAMERA.OK'), handler: () => setInvalidUrlAlert(false) }]}
      />
    </>
  );
};
